module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Acknowledgement"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_FM02"
    }
  }, [_c('i', [_vm._v("Note on Transliteration and Translation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1   "), _c('i', [_vm._v("Mente")]), _vm._v(": Consumer Grievances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2   Needs, Rights, and Protection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3   Consumer Activism?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4   Consumption as Civic Engagement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5   Consumer Politics after State Socialism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: “Enough Is Enough”—The Moral Commitment of the State")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix. An East Asian Ethnographer in Eastern Europe: Notes on Fieldwork and Positionality")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Reference",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b863104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Contents.vue
// module id = 72
// module chunks = 0